import "core-js/modules/es.array.filter";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { getDict as _getDict } from '@/utils/dictionary';
import { Common } from '@/utils/common';
export default {
  data: function data() {
    return {
      page: 1,
      total: 10,
      pageSize: 10,
      tableData: [],
      searchInfo: {},
      isMobile: Common.isMobile
    };
  },
  methods: {
    filterDict: function filterDict(value, type) {
      if (this[type + 'Options']) {
        var rowLabel = this[type + 'Options'] && this[type + 'Options'].filter(function (item) {
          return item.value === value;
        });
        return rowLabel && rowLabel[0] && rowLabel[0].label;
      }

      return '';
    },
    filterDictItemLabel: function filterDictItemLabel(value, type) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var rowLabel;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this[type + 'Options']) {
                  _context.next = 5;
                  break;
                }

                rowLabel = _this[type + 'Options'] && _this[type + 'Options'].filter(function (item) {
                  return item.value === value;
                });
                return _context.abrupt("return", rowLabel && rowLabel[0] && rowLabel[0].label);

              case 5:
                _context.next = 7;
                return _this.getDict(type);

              case 7:
                return _context.abrupt("return", _this.filterDict(value, type));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    filterDictItem: function filterDictItem(value, type) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var rowLabel;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2[type + 'Options']) {
                  _context2.next = 5;
                  break;
                }

                rowLabel = _this2[type + 'Options'] && _this2[type + 'Options'].filter(function (item) {
                  return item.value === value;
                });
                return _context2.abrupt("return", rowLabel && rowLabel[0]);

              case 5:
                _context2.next = 7;
                return _this2.getDict(type);

              case 7:
                return _context2.abrupt("return", _this2.filterDictItem(value, type));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getDict: function getDict(type) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var dictData;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _getDict(type);

              case 2:
                dictData = _context3.sent;
                _this3[type + 'Options'] = dictData || [];
                return _context3.abrupt("return", dictData);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData().then(function (r) {
        return function () {
          console.log(r);
        };
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getTableData().then(function (r) {
        return function () {
          console.log(r);
        };
      }); // 经测试，then回调无效
    },
    getTableData: function getTableData() {
      var _arguments = arguments,
          _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var page, pageSize, fn, table;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : _this4.page;
                pageSize = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : _this4.pageSize;
                fn = _arguments.length > 2 ? _arguments[2] : undefined;
                _context4.next = 5;
                return _this4.listApi(_objectSpread({
                  page: page,
                  pageSize: pageSize
                }, _this4.searchInfo));

              case 5:
                table = _context4.sent;

                if (table.code === 0) {
                  _this4.tableData = table.data.list;
                  _this4.total = table.data.total;
                  _this4.page = table.data.page;
                  _this4.pageSize = table.data.pageSize;
                }

                if (fn) {
                  fn(table);
                }

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    goBack: function goBack() {
      this.$router.push(this.$route.params.gobackRouter);
    },
    onCopy: function onCopy(url) {
      var el = document.createElement('input');
      el.setAttribute('value', url);
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.$message({
        type: 'success',
        message: '已复制'
      });
    },
    getStationName: function getStationName(id) {}
  }
};